import { DomLayoutType } from "ag-grid-community";

export enum FILEUPLOAD {
  MAX_SIZE = 25* 1024 * 1024,
}

export const MESSAGES = {
  successUpload: 'File successfully uploaded',
  errorUpload: 'File upload failed. Please try again.',
  invalidFileType: 'Invalid file type. Allowed types: ',
  fileSizeExceed: 'File size exceeds ',
  invalidUser: 'Invalid user. Please try again.',
  invalidCompany: 'Invalid company. Please try again.'
};

export const FileUploadConfig = {
  DNB_REPORT_HEADER: 'D&B REPORT',
  AR_REQ_FILE: 'Request A/R #',
  SELECTED_FILE_LABEL: 'Selected file: ',
  drag_and_drop:'Drag and Drop your file here, or ',
  browse:'browse',
  cancel:'Cancel',
  save:'Save',
  view:'View',
  remove:'Remove',
  back:'Back',
  sendArrequest:'Send A/R # Request',
  uploadPhoto:'Upload Photo',
  resetPhoto:'Reset Photo',
  po: 'po',
  coi: 'coi',
  tpcoi:'tpcoi',
  addFile: 'Add',
  removeFile: 'Remove',
};

export const PAGINATION_TEXT = {
  itemsperpage: 'Items per page',
  of: 'of',
};
// help.constants.ts
export const HELP_CONTENT = {
  defaultList :{
  title: 'Title:',
  content: 'Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Aenean lacinia bibendum nulla sed consectetur. Vestibulum id ligula porta felis euismod semper.',
  help: 'Need More Help?',
  faqs: 'Read our ',
  linkText: 'FAQs',
  },
  list: {
    title2: 'List of acceptable guarantors:',
    content: 'Abominable Pictures Inc.,Amblin Partners,Awesomeness,Blumhouse Productions LLC.($10k per show),DreamWorks,Electus LCC,FremantleMedia,Funny or Die($10k per show),IMG(WME-IMG),Lakeshore Entertainment,Legendary Pictures,Marvel,Lionsgate,MRC,Netflix,Starz Entertainment,Tristar Production Inc,STX Entertainment'
  },
  close: 'Close Help >',
};


export const maintenaceConst = [
  {
    mainteneceMsg:
      'The WB Theatrical Portal will be down for maintenance starting Friday March 29th from 3:00PM PDT until Sunday March 31st 12:00PM PDT.',
  },
  {
    mainteneceMsg:
      'If you need booking assistance, please email wbportalhelp@warnerbros.com',
  },
];

export const ADD_COMPANY_USER = {
  firstname: 'First Name',
  lastname: 'Last Name',
  email: 'Email',
  jobtitle: 'Job Title',
  optional: 'Optional Settings',
  companyadmin: 'Make the user a company admin',
  accountpay: 'User is an Accounts Payable user',
  verfication:
    ' A verification email will be sent to the new user after approval from WBSO.',
  project: 'Projects',
  active: 'Active',
  close: 'Closed',
  notstarted: 'Not Started',
  adduser: 'Add User',
  edit: 'Edit',
  department: 'Departments',
  permissions: 'Permissions',
  projectview: 'Project (View)',
  projectname: 'The Court - Season 1',
  fieldRequired: 'This field is required',
  firstNameInvalid: 'First Name is not valid',
  lastNameInvalid: 'Last Name is not valid',
  emailInvalid: 'Please enter a valid email address',
  jobTitleInvalid: 'Job title is invalid',
  makeuser: 'Make the user a company admin',
  accountpayable: ' User is an Accounts Payable user',
  spaceerror: 'Please remove any extra spaces before or after the text.',
  twospaceerror: 'Please remove extra spaces between words.',
  noactiveproject: 'There are no active projects associated with this company.',
  noclosedproject: 'There are no closed projects associated with this company.',
  nonotstartedproject: 'There are no not started projects associated with this company.',
  maxLengthExceeded: 'Max length exceeded',
  minLengthErr: 'Min length is 10 characters',
  invalidPhoneNo: 'Invalid phone number',
  activeproject: 'activeproject',
  closedproject: 'closedproject',
  notstartedproject: 'notstartedproject',
  departmentsIds: 'departmentsIds',
  userRoleIds: 'userRoleIds',
  selectCompany: 'Please select a Company',
  specialCharactersOnly: 'Special characters alone are not allowed.'
};

export const ADD_PROJECT_USER = {
  department: 'Departments Access',
  access: 'Access',
  section: 'Sections & Permissions',
  project: 'Project',
  credit: 'Credit Application',
  manageuser: 'Manage Users',
  canadd:
    'Can add, remove users to this project & manage their access and permissions',
  firstname: 'First Name',
  lastname: 'Last Name',
  email: 'Email',
  jobtitle: 'Job Title',
  optional: 'Optional Settings',
  makeuser: 'Make the user a company admin',
  accountpayable: ' User is an Accounts Payable user',
  verification:
    'A verification email will be sent to the new user after approval from WBSO.',
  projectuser: 'Add a User To',
  close: 'Close',
  fieldRequired: 'This field is required',
  firstNameInvalid: 'First name is not valid',
  lastNameInvalid: 'Last name is not valid',
  emailInvalid: 'Please enter a valid email address',
  jobTitleInvalid: 'Job title is invalid',
  phoneRequired: 'This field is required',
  phoneInvalid: 'This is an invalid phone number',
  minLength: 'Min length is 10 characters',
  addUserSuccessMsg: 'Project user added successfully',
  addProjectUserSuccess: 'PROJECT USER ADDED SUCCESSFULLY',
  addUserErrorMsg: 'ERROR CREATING THE USER',
  updateUserSuccess: 'User Updated Successfully',
  updateErrorMessage: 'ERROR IN UPDATING THE USER',
  projectUserStatus: 'Y',
  userId: 'User ID #',
  phoneInvalidNo: 'Invalid phone number',
  spaceerror: 'Please remove any extra spaces before or after the text.',
  twospaceerror: 'Please remove extra spaces between words.',
  permissionAccountsPayableErr: 'Accounts Payable user must have a Credit Application permission assigned for at least one project.',
  maxLengthExceeded: 'Max length exceeded',
  specialCharactersOnly: 'Special characters alone are not allowed.'
};

export const SECTION_DATA = [
  {
    "id": 1,
    "name": "Project",
    "roleSection": "Project",
    "permissions": ["Can View", "Can Manage"]
  },
  {
    "id": 2,
    "name": "Credit Applications",
    "roleSection": "Credit Application"
  },
  {
    "id": 3,
    "name": "Manage Users",
    "roleSection": "Manage User"
  }
]


export const SECTION_DATA_VALUE = [
  {
    portaltype: 'customer',
    dbvalue: {
      projectView: 'customer_project view only',
      projectViewMange: 'customer_project view and manage',
      creditViewMange: 'customer_credit application view and manage',
      userViewMange: 'customer_manage users view and manage'
    },
    viewText:
    {
      projectView: "Project (View)",
      projectViewMange: "Project (View and Manage)",
      creditViewMange: "Credit (View and Manage)",
      userViewMange: "User (View and Manage)"
    }
  },
  {
    portaltype: 'studio',
    dbvalue: {
      projectView: 'customer_project view only',
      projectViewMange: 'customer_project view and manage',
      creditViewMange: 'customer_credit application view and manage',
      userViewMange: 'customer_manage users view and manage',
    },
    viewText:
    {
      projectView: "Project (View)",
      projectViewMange: "Project (View and Manage)",
      creditViewMange: "Credit (View and Manage)",
      userViewMange: "User (View and Manage)"
    }
  },
]

export const COMMON_AG_GRID_CONSTANTS = {
  items: 'Items per page',
};

export const REQUEST_PAGINATION_STORAGE_PREFIX = 'request-pagination-';
export const COMPANIES_PAGINATION_STORAGE_PREFIX = 'companies-pagination-';
export const CREDIT_APPLICATION_PAGINATION_STORAGE_PREFIX = 'credit-application-pagination-';
export const USERS_PAGINATION_STORAGE_PREFIX = 'users-pagination-';
export const PROJECTS_PAGINATION_STORAGE_PREFIX = 'projects-pagination-';
export const CUSTOMER_REQUESTS_PAGINATION_STORAGE_PREFIX = 'customer-requests-pagination-';
export const CUSTOMER_USERS_PAGINATION_STORAGE_PREFIX = 'customer-users-pagination-';
export const CUSTOMER_PROJECTS_PAGINATION_STORAGE_PREFIX = 'customer-projects-pagination-';
export const CUSTOMER_CREDIT_APPLICATION_PAGINATION_STORAGE_PREFIX = 'customer-credit-application-pagination-';
export const AR_COMPANIES_PAGINATION_STORAGE_PREFIX = 'ar-companies-pagination-';
export const AR_USERS_PAGINATION_STORAGE_PREFIX = 'ar-users-pagination-';
export const AR_PROJECTS_PAGINATION_STORAGE_PREFIX = 'ar-projects-pagination-';
export const AR_DASHBOARD_PAGINATION_STORAGE_PREFIX = 'ar-dashboard-pagination-';
export const LEGACY_REQUEST_PAGE_SIZE_PREFIX = 'request-page-size-';
export const PAGINATION_STORAGE_PREFIXES = [
  REQUEST_PAGINATION_STORAGE_PREFIX,
  COMPANIES_PAGINATION_STORAGE_PREFIX,
  CREDIT_APPLICATION_PAGINATION_STORAGE_PREFIX,
  USERS_PAGINATION_STORAGE_PREFIX,
  PROJECTS_PAGINATION_STORAGE_PREFIX,
  CUSTOMER_REQUESTS_PAGINATION_STORAGE_PREFIX,
  CUSTOMER_USERS_PAGINATION_STORAGE_PREFIX,
  CUSTOMER_PROJECTS_PAGINATION_STORAGE_PREFIX,
  CUSTOMER_CREDIT_APPLICATION_PAGINATION_STORAGE_PREFIX,
  AR_COMPANIES_PAGINATION_STORAGE_PREFIX,
  AR_USERS_PAGINATION_STORAGE_PREFIX,
  AR_PROJECTS_PAGINATION_STORAGE_PREFIX,
  AR_DASHBOARD_PAGINATION_STORAGE_PREFIX,
  LEGACY_REQUEST_PAGE_SIZE_PREFIX,
];
export const PERSISTENT_LOCAL_STORAGE_PREFIXES: string[] = [];

export const COMMON_GRID_OPTIONS = {
  pagination: true,
  paginationPageSize: 10,
  domLayout: 'autoHeight' as DomLayoutType,
  defaultColDef: {
    flex: 1,
    minWidth: 100,
    filter: false,
    autoHeight: true,
  },
};

export const PROJECT_DOCUMENT_CONSTANTS = {
  document: 'Documents',
  uploadAFile: 'Upload a file',
  uploadDocument: 'Upload Document',
  dragAndDrop: 'Drag and Drop your file here, or ',
  browse: 'browse',
  addComment: 'ADD A COMMENT:',
  cancel: 'Cancel',
  add: 'Add',
  remove: 'Remove',
  view: 'View',
  noDocuments: 'No Documents To Display',
  noteText: 'Project document test comment',
  fileName: 'File Name',
  size: '1.2 MB',
  addedBy: 'first last name',
  addedOn: '1/1/2026',
  uploadedOn: 'Uploaded on',
  by: 'By',
  close: 'Close',
  viewComment: 'View comment',
  noComment: 'No comment available',
  download: 'download',
  removeConfirm: 'Are you sure you want to delete this file?',
  yes: 'Yes',
  removeSuccess: 'File deleted successfully',
  removeError: 'File deletion failed. Please try again.'
}
export const PROJECT_DOCUMENT_UPLOAD = {
  sectionType: 'projectdocs',
  documentType: 'Project',
  section: 'projectdocs',
  acceptType: 'application/pdf',
  maxSize: 5 * 1024 * 1024,
  invalidType: 'File type is not supported. Please select a supported file format.',
  invalidFileExtension: 'File extension is not supported. Allowed extensions: .pdf, .jpg, .jpeg, .png, .doc, .docx, .rtf, .xls, .xlsx, .csv, .ppt, .pptx.',
  sizeExceeded: 'File size exceeds the 5MB limit. Please select a smaller file.',
  dropOnlyOneFile: 'You can drop only one file',
  invalidFileName: "Invalid file name. Only letters, numbers, '_', '-', and spaces are allowed.",
  duplicateFileName: 'A file with this name already exists on this project',
};

export const PROJECT_DOCUMENT_ALLOWED_UPLOAD_FILE_EXTENSIONS = [
  'pdf',
  'jpg',
  'jpeg',
  'png',
  'doc',
  'docx',
  'rtf',
  'xls',
  'xlsx',
  'csv',
  'ppt',
  'pptx',
];

export const PROJECT_DOCUMENT_ALLOWED_UPLOAD_FILE_MIME_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/rtf',
  'text/rtf',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/csv',
  'application/csv',
  'application/vnd.ms-excel.sheet.macroenabled.12',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
];

export const PROJECT_DOCUMENT_FILE_NAME_REGEX = /^[a-zA-Z0-9_\-\s]+\.(pdf|jpg|jpeg|png|doc|docx|rtf|xls|xlsx|csv|ppt|pptx)$/i;

export const PROJECT_DOCUMENT_VIEWER = {
  // Browsers cannot render Office formats, so they are handed to an online viewer.
  officeViewerUrl: 'https://view.officeapps.live.com/op/view.aspx?src=',
  officeViewerExtensions: ['doc', 'docx', 'xls', 'xlsx'],
  // Formats the Office web viewer rejects are previewed through the Google viewer instead.
  googleViewerUrl: 'https://docs.google.com/viewer?url=',
  googleViewerExtensions: ['ppt', 'pptx', 'rtf'],
  loadingTabTitle: 'Opening document...',
};
export const ADD_WB_USER_TITLE = 'Add A WB User';
export const ADD_CUSTOMER_USER_TITLE = 'Add A Customer User';
export const ADD_USER_TITLE = 'Add User';
export const SEARCH_USER_TEXT = 'Search User';
export const PLACEHOLDER_TEXT = 'Search user name or email address';
export const SEARCH_PLACEHOLDER = 'Search'; // Add this line
export const ADD_WB_SEARCH_SUCCESS = 'WBSO added Successfully';
export const ADD_WB_SEARCH_ERROR = 'WBSO added Successfully';

export const AR_SECTION_TITLES = {
  permissions: 'Permissions',
  access: 'ACCESS',
  finalReview: 'Final Review',
  arNumber: 'A/R Number',
  finalReviewDescription: 'Approve or Deny Credit Application',
  arNumberDescription: 'Can add and edit the A/R number'
};

export const REVISION = {
  revisionsNeeded: "Revisions needed:",
  uploadPurchaseOrder: "Upload a Purchase Order",
  uploadCertificateOfInsurance :"Upload a certificate of Insurance",
  purchaseOrder : "Purchase Order",
  certificateOfInsurance: "Certificate Of Insurance",
  needsRevision : "NEEDS REVISIONS",
  docUploadSuccess : "Document Uploaded Successfully",
  docRemoveSuccess: "Document Removed Successfully",
  submitRevision: "Submit Revision",
  yes: 'Yes',
  no: 'No',
  discardChangesMessage: 'Are you sure you want to discard changes without saving?',

}


export const ADD_EDIT_COMPNAY = {
  companytype: "Company Type",
  internal: "For Internal use only",
  companyname: "Production Company Name",
  name: "Name",
  legalname: "The Production Legal Name",
  billingaddress: "Billing Address",
  companyaddress: "Production Company Address",
  contacts: "Contacts",
  country: "Country",
  street: "Street",
  city: "City",
  cities:"City/Town",
  state: "State",
  zipcode: "Zip Code",
  billing: "Use for Billing Address",
  firstname: "First Name",
  lastname: "Last Name",
  email: "Email",
  jobtitle: "Job Title",
  phone: "Phone",
  federal: "Federal Tax ID #",
  federallabel: "TIN",
  addcontact: "Add a Contact",
  removecontact: "Remove Contact",
  addcompany: "Add Company",
  postalcode: "Postal Code",
  province: 'Province',
  stateinput: 'State/Province/Region',
  editcompany: 'Edit A Company',
  gotopage: 'gotopage',
  savechanges: 'Save Changes',
  discardchanges: 'Discard Changes',
  zippostalcode: 'ZIP/Postal Code'
}

export const ADD_EDIT_COMPNAY_DROPDOWN = [
  { id: 1, description: 'Projects' },
  { id: 2, description: 'Users' },
  { id: 3, description: 'Spaces & Resources' },
  { id: 4, description: 'Company' },
];

export const POP_UP_CELL_RENDERED = {
  moreActions: 'MORE ACTIONS',
  deactivateUser: 'Deactivate User',
  freezeAccount: 'Freeze Account',
  removeUser: 'Remove User',
};

export const ICONS_RENDERED = {
  areYouSure: 'Are you sure you want to delete?',
  closeProjectCreationPage: 'Are you sure you want to close the project creation page without saving?',
  closeUserCreationPage: 'Are you sure you want to close the user creation page without saving?',
  ok: 'OK',
  cancel: 'Cancel',
  yes: 'Yes',
  no: 'No',
  restrictDisableCompany: 'Company can’t be disabled because there are active projects associated with this company.',
  restrictUserCompany: 'There are no active projects associated with this company.',
  editcloseProjectCreationPage: 'Are you sure you want to discard changes without saving?',
  comfirmationText: 'Are you sure you want to cancel this request?',
  cancellationComment: 'CANCELLATION COMMENT',
  discard: 'Discard',
  confirm: 'Confirm',
  cancellationErrorComment: 'Cancellation comment is required.',
};
export const GO_TO_DROPDOWN = [
  { id: 1, description: "Company" },
  { id: 2, description: "Projects" },
  { id: 3, description: "Users" }
];

export const GO_TO_DROPDOWN_DEFAULT = {
  goTo: 'Go To…',
  activeProjects: 'ACTIVE PROJECTS'
}

export const COMPANY_TYPES = [
  { id: 1, description: 'Warner Affiliate' },
  { id: 2, description: 'Major Studio' },
  { id: 3, description: '3rd Party' },
  { id: 4, description: '3rd Party Commercial House' }
];
export const COMPANY = {
  companyname: "Sunshine Productions",
  companyid: 'COMPANY ID #',
  projects: 'Projects',
  companyaddress: 'Company Address',
  contactinfo: 'Contact Information',
  companyuser: 'Company Users',
  creditstatus: 'Company Status',
  adduser: 'Add a User',
  viewall: 'View All',
  valid: 'Valid Until 12/12/24',
  current: 'Current',
  editcompany: 'Edit Company',
  addcompany: 'Add a Company',
  portaltype: 'customer',
  modalType: 'edit',
  addProject: 'Add a Project',
  internaluse: 'FOR INTERNAL USE ONLY',
  companytype: 'Company Type',
  enablecompany: 'Enable Company',
  disablecompany: 'Disable Company',
  addcustomeruser: 'Add a Customer User',
  addproject: 'Add a Project',
  allcompanies: 'All companies',
  addnewproject: 'Add A New Project',
  companytitle: 'Company',
  modalAdd: 'add',
  studioComponentType: 'studio-company',
  studioPortalType: 'studio'

};
export const ADD_COMPNAY_PROJECT = {
  companyname: "Sunshine Productions",
  companyid: 'COMPANY ID #',
  projects: 'Projects',
  companyaddress: 'Company Address',
  contactinfo: 'Contact Information',
  companyuser: 'Company Users',
  creditstatus: 'Company Status',
  adduser: 'Add a User',
  viewall: 'View All',
  valid: 'Valid Until 12/12/24',
  current: 'Current',
  editcompany: 'Edit Company',
  addcompany: 'Add a Company',
  portaltype: 'customer',
  modalType: 'edit',
  addProject: 'Add a Project',
  internaluse: 'FOR INTERNAL USE ONLY',
  companytype: 'Company Type',
  enablecompany: 'Enable Company',
  disablecompany: 'Disable Company',
  addcustomeruser: 'Add a Customer User',
  addproject: 'Add a Project',
  allcompanies: 'All companies',
  addnewproject: 'Add A New Project',
  companytitle: 'Company',
  companyTitle: 'Company',
  changeCompany: 'Change Company',
  openCompany: 'Open Company',
  selectCompany: 'Select Company',
  projectName: 'Project Name',
  projectCompanyName: 'Project Company Name',
  projectDetails: 'Project Details',
  projectType: 'Project Type',
  anticipatedDates: 'Anticipated Project Dates',
  internal: 'For Internal Use Only',
  primaryType: 'Primary Payment Type',
  addProjectBtn: 'Add Project',
  addGoProjectBtn: 'Add & Go To Project',
  customertype: 'Customer Type',
  primaryPaymentType: 'Primary Payment Type'
};
export const COUNTRIES = [
  { "id": 1, "name": "Afghanistan" },
  { "id": 2, "name": "Åland Islands" },
  { "id": 3, "name": "Albania" },
  { "id": 4, "name": "Algeria" },
  { "id": 5, "name": "American Samoa" },
  { "id": 6, "name": "Andorra" },
  { "id": 7, "name": "Angola" },
  { "id": 8, "name": "Anguilla" },
  { "id": 9, "name": "Antarctica" },
  { "id": 10, "name": "Antigua and Barbuda" },
  { "id": 11, "name": "Argentina" },
  { "id": 12, "name": "Armenia" },
  { "id": 13, "name": "Aruba" },
  { "id": 14, "name": "Australia" },
  { "id": 15, "name": "Austria" },
  { "id": 16, "name": "Azerbaijan" },
  { "id": 17, "name": "Bahamas" },
  { "id": 18, "name": "Bahrain" },
  { "id": 19, "name": "Bangladesh" },
  { "id": 20, "name": "Barbados" },
  { "id": 21, "name": "Belarus" },
  { "id": 22, "name": "Belgium" },
  { "id": 23, "name": "Belize" },
  { "id": 24, "name": "Benin" },
  { "id": 25, "name": "Bermuda" },
  { "id": 26, "name": "Bhutan" },
  { "id": 27, "name": "Bolivia" },
  { "id": 28, "name": "Bosnia and Herzegovina" },
  { "id": 29, "name": "Botswana" },
  { "id": 30, "name": "Bouvet Island" },
  { "id": 31, "name": "Brazil" },
  { "id": 32, "name": "British Indian Ocean Territory" },
  { "id": 33, "name": "Brunei Darussalam" },
  { "id": 34, "name": "Bulgaria" },
  { "id": 35, "name": "Burkina Faso" },
  { "id": 36, "name": "Burundi" },
  { "id": 37, "name": "Cambodia" },
  { "id": 38, "name": "Cameroon" },
  { "id": 39, "name": "Canada" },
  { "id": 40, "name": "Cape Verde" },
  { "id": 41, "name": "Cayman Islands" },
  { "id": 42, "name": "Central African Republic" },
  { "id": 43, "name": "Chad" },
  { "id": 44, "name": "Chile" },
  { "id": 45, "name": "China" },
  { "id": 46, "name": "Christmas Island" },
  { "id": 47, "name": "Cocos (Keeling) Islands" },
  { "id": 48, "name": "Colombia" },
  { "id": 49, "name": "Comoros" },
  { "id": 50, "name": "Congo" },
  { "id": 51, "name": "Congo, The Democratic Republic of The" },
  { "id": 52, "name": "Cook Islands" },
  { "id": 53, "name": "Costa Rica" },
  { "id": 54, "name": "Cote D'ivoire" },
  { "id": 55, "name": "Croatia" },
  { "id": 56, "name": "Cuba" },
  { "id": 57, "name": "Cyprus" },
  { "id": 58, "name": "Czech Republic" },
  { "id": 59, "name": "Denmark" },
  { "id": 60, "name": "Djibouti" },
  { "id": 61, "name": "Dominica" },
  { "id": 62, "name": "Dominican Republic" },
  { "id": 63, "name": "Ecuador" },
  { "id": 64, "name": "Egypt" },
  { "id": 65, "name": "El Salvador" },
  { "id": 66, "name": "Equatorial Guinea" },
  { "id": 67, "name": "Eritrea" },
  { "id": 68, "name": "Estonia" },
  { "id": 69, "name": "Ethiopia" },
  { "id": 70, "name": "Falkland Islands (Malvinas)" },
  { "id": 71, "name": "Faroe Islands" },
  { "id": 72, "name": "Fiji" }
]
export const REGEX_CONSTANTS = {
  PHONE_NUMBER: /^[0-9+\-() \s]*$/,
  FEDERAL_TAX_ID: /^[0-9\- ]*$/,
  ALPHABETIC: /^[A-Za-z\s]*$/,
  NAME_VALIDATION: /^[A-Za-z]+(\s[A-Za-z]+)*$/,
  JOB_TITLE: /^[a-zA-Z0-9\s\-_.&@!]+$/,
  ALPHANUMERIC: /^[a-zA-Z0-9]*$/,
  NUMERIC: /^[0-9]+$/,
  NAMES: /^[A-Za-z]+(?: [A-Za-z]+)*$/,
  USZIPCODE: /^[0-9]{1,5}$/,
  UKCANPOSTAL: /^[A-Za-z0-9\s]{1,12}$/,
  GENPOSTAL: /^[A-Za-z0-9\s]{1,12}$/,
  SEARCH_COMPANY_NUMBER: /^\d+$/
};

export const MERGED_CELL_ICONS = {
  disabled: 'DISABLED',
  active: 'ACTIVE'
}

export const MULTISELECT = {
  apply: 'Apply',
  close: 'Close',
  placeholder: 'Select',
  typeaheadplaceholder: 'Search'
};

export const USER = {
  userName: 'User Name',
  profile: 'Profile',
  settings: 'Settings',
  emailNotifications: 'Email Notifications',
  profileTab: 'profile-tab',
  settingsTab: 'settings-tab',
  emailNotificationstab: 'email-notifications-tab',
  successfullMessage: "User Profile has been successfully updated",
  errorMessage: 'Error in updating the profile',
  warn: 'Profile data could not be retrieved.',
  error: 'Error fetching user profile',
  updateError: 'Error updating profile',
  invalidField: 'This Field is invalid',
  warningMessage: 'Are you sure you want proceed without saving changes?',
  yes: 'Yes',
  no: 'No'
};

export const SETTINGS = {
  settings: 'Settings',
  timeZone: 'TIME ZONE',
  validatorRequired: 'This is required filed',
  dateFormat: 'DATE FORMAT',
  calendarFormat: 'CALENDAR FORMAT',
  startSunday: '',
  startMonday: '',
  timeFormat: 'TIME FORMAT',
  temperatureUnit: 'PREFERRED TEMPERATURE UNIT',
  fahrenheit: '',
  celsius: '',
  save: 'Save',
  dateFormat1: '',
  dateFormat2: '',
  timeFormat1: '',
  timeFormat2: '',
  timeZoneDefault: '',
  calendarFormatDefault: '',
  fahrenheitDefault: '',
};

export const SETTINGS_DATA = {
  fahrenheit: 'Fahrenheit',
  time: '12h',
  dateFormat: 'm/d/yyyy',
  calendarFormat: 'starts on Sunday',
}

export const PROJECT_ERROR_MSG = {
  errorProjectUser: 'Error fetching project user',
}

export const PORTAL_TYPE = {
  studioPortal: 'studio',
  arPortal: 'ar',
  studioTypeAdd: 'addProjectUser',
  studioTypeEdit: 'updatProjectUser',
  accountsPayableUser: 'accountsPayableUser',
}

export const WBCONSTANT_DATA = {
  wbsoAR: 10,
  deptmartmentUser: 6,
  department: 7,
  statusActiveInd: 'Y',
  loginUserId: 1,
}

export const SEARCH_DATA = {
  searchUser: 'Search User',
  search: 'Search',
}

export const ICONS_ACTION = {
  freezeAccount: 'freeze-account',
  deActivate: 'deactivate-account',
  activate: 'activate-account',
  remove: 'remove-account',
  disableCompany: 'disable-company',
  enableCompany: 'enable-company',
  deactivateCompanyUser: 'deactivateCompanyUser',
  activateCompanyUser: 'activateCompanyUser',
  retriggerRequestUser: 'retriggerRequestUser',
  cancelRequest:'cancelRequest'
}

export const ACTION_MSG = {
  freezeAccount: 'Are you sure you want to test the account?',
  deActivate: 'Are you sure you want to deactivate the user?',
  activate: 'Are you sure you want to reactivate the user?',
  remove: 'Are you sure you want to remove the user?',
  disableCompany: 'Are you sure you want to disable this company?',
  enableCompany: 'Are you sure you want to enable this company?',
  retriggerRequest: 'Are you sure you want to retrigger this request?',
  cancelRequest:'Are you sure you want to cancel this request?'
}

export const ICONS_CASE = {
  freeze: 'freeze',
  deActivate: 'deactivate',
  activate: 'activate',
  remove: 'remove',
  disableCompany: 'disable-company',
  enableCompany: 'enable-company',
  deactivateCompanyUser: 'deactivateCompanyUser',
  activateCompanyUser: 'activateCompanyUser',
  retrigger: 'retriggerRequestUser',
  cancelRequest:'cancelRequest'
}

export const FORM_VALIDATION = {
  phoneValidation: /^(?!.*\s{2})(?!\s)[0-9\+\-\(\)\s]*[0-9](?<!\s)$/,
  cityValidation: /^[a-zA-Z0-9\s]{1,50}$/,
  streetValidation: /^(?=.*[A-Za-z0-9])(?! )(?!.* {2,})(?!.* $)[A-Za-z0-9 !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]{1,85}$/,
  zipCodeValidation: /^[0-9]{1,12}$/,
  phoneNovalidation: /^[0-9\+\-\(\)\s]*$/,
  emailValidation: /^(?!\.)(?!.*\.\.)([a-zA-Z0-9_%+]+([.-][a-zA-Z0-9_%+]+)*)@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/,
  emailValidationHTMLPattern: '^(?!\\.)(?!.*\\.\\.)([a-zA-Z0-9_\\%\\+]+([.-][a-zA-Z0-9_\\%\\+]+)*)@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$',
  tinValidation: /^[0-9-\s]+$/,
  alphaNumericValidation: /^[A-Za-z0-9]*$/,
  projectName: /^[A-Za-z0-9\s!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~]*$/,
  streetValidationSpecialChar:/^[a-zA-Z0-9@#?!&.,\-()'"/:;+\s_]{1,85}$/,
  emailValidationCompany:/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

}

export const COMPANY_SEARCH_MESSAGES = {
  invalidCompanyId: 'Invalid Company ID#',
  invalidCompanyName: 'No Company To Display',
  invalidCompanyNameSearch: 'Invalid Company Name',
  search: 'Search'
}

export const SAVE_CHANGES_WARNING = {
  message: 'Are you sure you want to close the user creation page without saving?',
  message1:'Are you sure you want to discard changes without saving?',
  yes: 'Yes',
  no: 'No'
}

export const APPROVAL_LETTER_FORMAT = {
  htmldata: '<p>Dear Accounts Payable,</p><p>Having reviewed your application for credit, Warner Bros. Studio Operations (WBSO) is pleased to advise you that we have established an account for you. WBSO would like to take this opportunity to welcome you as a customer and acquaint you with our practices. Please read the letter in attachments.</p><p>Please contact <a href="mailto:CustomerRequest@wbd.com">CustomerRequest@wbd.com</a> if there are any questions.<br/>Thanks,<br/>WBSO A/R</p>'
}
export const SEND_APPROVAL_LETTER_DATA = {
  title: 'Send Letter of Approval',
  company: 'Company',
  companyName: 'A Brand New Production Company',
  project: 'Project',
  projectName: 'The New Show',
  accountPayable: 'Accounts Payable contact(s)',
  accountPayableEmail: 'Jane Doe (jdoe@domain.com)',
  addeditbtn: 'Add/Edit New',
  cancelbtn: 'Cancel',
  sendtocustomerbtn: 'Send to Customer'
}
export const COD_NOTIFICATION = {
  codTitle: 'Send COD Information',
  codCompany: 'Company',
  codCompanyName: 'A Brand New Production Company',
  codProject: 'Project',
  codProjectName: 'The New Show',
  accountPayableContact: 'Accounts Payable Contact(s)',
  accountPayableEmail: 'Jane Doe (jkdoe@domain.com)',
  addeditbtn: 'Add/Edit New',
  cancelbtn: 'Cancel',
  sendcustomerbtn: 'Send To Customer',
  addeditTitle: 'Add/Edit New Accounts Payable Contact',
  payableName: 'Name',
  payableNameValue: 'Jon Doe',
  payableEmail: 'Email',
  payableEmailValue: 'Jond@domain.com',
  newPayableName: ' ',
  newPayableNameValue: ' ',
  newPayableEmail: ' ',
  newPayableEmailValue: '',
  nameRequired: 'Name is required.',
  nameInvalid: 'Name is not valid',
  nameMinLength: 'Name must be at least 3 characters long.',
  nameMaxLength: 'Name must not exceed 100 characters.',
  lnameRequired: 'Last name is required.',
  lnameInvalid: 'Last name is not valid',
  lnameMinLength: 'Last name must be at least 1 characters long.',
  lnameMaxLength: 'Last ame must not exceed 100 characters.',
  emailRequired: 'Email is required.',
  invalidEmail: 'Email format is invalid.',
  removebtn: 'Remove Contact',
  addContactbtn: ' Add a Contact',
  no:'No',
  yes:'Yes',
  unsavedChangesWarning:'Are you sure you want to discard changes without saving?',
  backbtn:'Back',
  saveBtn:'Save Changes',
  cancelBtn: 'Cancel',
  departmentsToContact: 'Departments to contact are: ',
  departmentName: 'departmentName',
  errormessage:'Duplicate email address. Please enter a different email',
  errorCheck:'Name must contain only alphabets',
  errorCheckForDuplicateEmail:'AccountPayableContact EmailAddress already Exists for a CreditApplication.',
  errorCheckForDuplicateEmailThirdParty:'AccountPayableContact EmailAddress already Exists.',
  errorDelete: "We encountered an error. Please try again later.",
  errorNameMessage:'Name must contain only alphabets and length should be in between 1 to 50 characters.',
  newContactEmail: 'newContactEmail',
  statusValid: 'VALID',
  statusInvalid: 'INVALID',
  newContactName: 'newContactName',
  newContactLname: 'newContactLname',
  emailInvalid: 'Please enter a valid email address',
};
export const COD_EMAIL_FORMAT = {
  htmlData: '<p>Hello,</p><p>Thank you for submitting your credit information requested by WBSO A/R. Upon closer review of the information provided, it was compared to the WBSO credit guidelines for specific qualifying factors and elements. As a result, WBSO A/R cannot approve request for a line of credit with Net terms.</p><p>Alternatively, you can work with the WBSO Departments directly to create a cash account which will require cash, check, or credit card upfront for the potential work or rental. </p><p>Below are the links to our Costume, Property and other WBSO Departments which will provide the contact email and phone number for setting up a cash account.</p><p>Costumes: <a target="_blank" href="https://studiofacilities.warnerbros.com/costumes/">https://studiofacilities.warnerbros.com/costumes/ </a><br>Property: <a target="_blank" href="https://property.warnerbros.com">https://property.warnerbros.com</a><br>All Other WBSO Departments: <a target="_blank" href="https://studiofacilities.warnerbros.com/department-contacts/">https://studiofacilities.warnerbros.com/department-contacts/</a></p><p>If you have any questions, please let us know.</p><p>_______</p><p>WBSO A/R<br>WB Burbank</p>',
  replaceContent: '<p>Departments to contact are: </p>'
}

export const FINAL_CRED_FORM={
  title:'Line of Credit',
  lineofcredreq:'Line of Credit requested',
  lineofcredreqamt:'$xxx,xxx,xxx.xx',
  anticipatejobtotle:'Anticipated Job Total',
  anticipatejobtotleamt:'$xxx,xxx,xxx.xx',
  totalmonths:'Total # of months',
  totalnomonths:'2',
  letterofcredit:'Letter of Credit/',
  gurantee:'Guarantee',
  comment:'Comments',
  comments:'none',
  pdf:'signed.pdf',
  view:'View',
  company:'Company',
  name:'Name',
  companyName:'A Brand New Company',
  address:'Address',
  addressdetails:'2500 Main Street,Los Angeles, CA,92783',
  phone:'Phone',
  phoneno:'858556565',
  useofbill:'Use for billing address',
  federaltaxid:'Federal Tax ID #',
  tin:'TIN',
  tinno:'123456789',
  accountpayablecontact:'Accounts Payable Contact',
  accname:'Name',
  accnameValue:'A Brand New Company',
  accemail:'Email',
  accemailvalue:'name@domain.com',
  accphonetitle:'Phone',
  accphone:'858556565',
  companyprofile:'Company Profile',
  profile:'Profile',
  corparate:'Corporate',
  datestarted:'Date Started',
  date:'1/1/24',
  typeofbusiness:'Type of Business',
  typeofbusinessname:'Corporation',
  totalannual:'Total Annual Sales',
  totalannualamt:'$xx.xx',
  networth:'Net Worth',
  networthamt:'$xx,xx',
  ofemployee:'# of Employees',
  ofemployeeno:'0-25',
  principal:'Principals/Officers or Partners',
  principalname:'Name',
  principalValue:'John Doe',
  ofemployeetitle:'Title',
  ofemployeetitlevalue:'Job title',
  bankingref:'Banking Reference',
  bank:'Bank',
  bankname:'A Brand New Company',
  accntnotitle:'Account Number',
  accntno:'1234 5678 9012 3456',
  accntnametitle:'Name',
  accntnameValue:'John Doe',
  accntcomptitle:'Title',
  accntcompname:'A Brand New Comapny',
  accntcompemail:'Email',
  accntcompemailvalue:'name@domain.com',
  accntcompPhone:'Phone',
  accntcompPhoneno:'858556565',
  tradereferencetitle:'Trade Reference 1',
  tradereferencecompany:'Company',
  tradereferencename:'Name',
  tradereferencecontact:'Contact Name',
  tradereferencedate:'Data',
  tradereferenceaddress:'Address',
  tradereferenceaddressvalue:'2500 Main Street,Los angeles,CA 92783',
  tradereferenceemailtitle:'Email',
  tradereferenceemailValue:'name@domain.com',
  tradereferencephone:'Phone',
  tradereferencephoneno:'858556565',
  tradereferencepdf:'signed.pdf',
  tradereferenceview:'View',
  tradereferencetitle2:'Trade Reference 2',
  tradereferencecompany2:'Company',
  tradereferencename2:'Name',
  tradereferenceContact2:'Contact Name',
  tradereferencedate2:'Data',
  tradereferenceaddress2:'Address',
  tradereferenceaddressvalue2:'2500 Main Street,Los angeles,CA 92783',
  tradereferenceemailtitle2:'Email',
  tradereferenceemailValue2:'name@domain.com',
  tradereferencephone2:'Phone',
  tradereferencephoneno2:'858556565',
  tradereferencetitle3:'Trade Reference 3',
  tradereferencecompany3:'Company',
  tradereferencename3:'Name',
  tradereferenceContact3:'Contact Name',
  tradereferencedate3:'Data',
  tradereferenceaddress3:'Address',
  tradereferenceaddressvalue3:'2500 Main Street,Los angeles,CA 92783',
  tradereferenceemailtitle3:'Email',
  tradereferenceemailValue3:'name@domain.com',
  tradereferencephone3:'Phone',
  tradereferencephoneno3:'858556565',
  viewapplication:'View Application Form Activity',
  tc:'Terms & Conditions',
  tcname:'Name',
  tcnamevalue:'Catherine Dacker',
  tctitle:'Title',
  tctitlevalue:'Head of Accounting',
  tcsign:'Signature',
  tcsigned:'Yes',
  tcDate:'Date',
  tcDateValue:'xx/xx/xxx',
  tcViewcbtn:'View T&C Activity',
  certificate:'Certificate of',
  insurance:'Insurance',
  producer:'Producer',
  producername:'XYZ Broker Company',
  producerinsurance:'Insurance',
  producerinsurancename:'John Doe',
  produceraddress:'Address',
  produceraddressValue:'2500 Main Street,Los Angeles, CA, 92783',
  producerdocpdf:'signed.pdf',
  producerdocview:'View',
  viewcoiactivity:'View COI Activity',
  dandb:'D&B Report',
  dandbdoc:'signed.pdf',
  dandbview:'View',
  delliquency:'Deliquency Score',
  delliquencyno:'88',
  failurescore:'Failure Score',
  failurescoreno:'67',
  paydex:'PAYDEX® Score',
  paydexno:'72',
  viewdandbactivity:'View D&B Activity',
  search:'Search',
  cancel:'cancel',
  select:'Select',
  yes: 'Yes',
  no: 'No',
  prodCompanyAddress: 'Production Company Address',
  billingAddress: 'Billing Address',
  sameAddress: 'Same as Company Address',
  noActivity: 'No Activity',
}
 export const CRED_APPLICATION_FORM_ACTIVITY={
  title:'Credit Application Form Activity',
  namelogo:'AN',
  name:'Andrea Noj',
  commentdate:'xx/xx/xx xx:xxAM',
  comment:'Reviewed Certificate of Insurance',
  namelogo1:'AN',
  name1:'Andrea Noj',
  commentdate1:'xx/xx/xx xx:xxAM',
  comment1:'Reviewed Purchase Order',
  close:'Close'
 }
 export const  TERMS_CONDITION_ACTIVITY={
  activityTitle:'Terms & Conditions Activity',
  activityData:'No Activity',
  closeBtn:'Close'
 }
 export const DANDB_REPORT_ACTIVITY={
 activityTitle:'D&B Report Activity',
 activityData:'No Activity',
  closeBtn:'Close'
 }
 export const CERTIFICATE_OF_INSURANCE_ACTIVITY={
  activityTitle:'Certificate of Insurance Activity',
  activityData:'No Activity',
  closeBtn:'Close'
 }
 export const THIRD_PARTY_PORTALTYPE={
 Ar:'ar',
 STUDIO:'studio'
 }

 export const STUDIO_WBSO_USER_ROLE={
  wbso:'wbso',
  departmentUser:'Department User',
  departmentHead:'Department Head',
  client_services: "CSR",
  system_admin: "System Admin",
  }

 export const CUSTOMER_USER_ROLE={
  companyAdmin:'customer_company admin',
  projectViewManage:'customer_project view and manage',
  }

 export const WBSO_AR_NUMBER={
  wbsoARNumber:'wbso_ar number',
}

export const ADD_USER = {
  activeproject : 'activeproject'
}
  

  export const THIRD_PARTY_COMPANY_TYPE = {
    thirdPartyCommercialHouse: '3rd Party Commercial House'
  }

export const EMAIL_TEMPLATE_ROUTE = {
  customer_portal: 'customer-dashboard/project-details',
  customer_request_path: 'customer-dashboard/requests',
  studio_request_path: 'studio-dashboard/studio-request'
}

export const SIDEBAR_SALES = {
  active: 'Active',
  project: 'Project: ',
  user: 'User: ',
  company: 'Company: ',
  projectId: 'Project Id: ',
  createLink: 'Share Form',
  generateLink: 'Copy Link',
}

export const FILE_UPLOAD_TOAST_MESSAGES = {
  sizeLimit25MBErrMsg: 'File size exceeds the 25MB limit. Please select smaller file.',
  sizeLimit20MBErrMsg: 'File size exceeds the 20MB limit. Please select smaller file.',
  invalidFileType: 'File type is not supported. Please select a valid .pdf file',
  OnlyOneFileIsAllowed: 'You can drop only one file',
  fileNameNotAllowed: "Invalid file name. Only letters, numbers, '_', '-', and spaces are allowed.",
  combinedSizeLimit: "The total size of uploaded files cannot exceed 20MB. Please remove one or more files to continue."
}

export const CREDIT_APP_TOAST_MESSAGES = {
  insuranceSuccess: 'Certificate Of Insurance Saved Successfully',
  creditApplication: 'Application Form Saved Successfully',
  reviewSuccess: 'Credit Application Submitted Successfully',
  uploadSuccess: 'Certificate Of Insurance Uploaded Successfully',
  removeSuccess: 'Certificate Of Insurance Removed Successfully',
  tradeReferenceSuccess: 'Trade Reference Uploaded Successfully',
  tradeReferenceRemoveSuccess: 'Trade Reference Removed Successfully',
  fileMoreThan25MBErrMsg: 'File size exceeds 25MB limit',
  fileMoreThan20MBErrMsg: 'File size exceeds 20MB limit',
  fileMoreThan100MBErrMsg: 'File size exceeds 25MB limit',
  fileMoreThan5MBErrMsg: 'File size exceeds 25MB limit',
  dropOnlyOneFile: 'You can drop only one file',
  selectPdfFile: 'Please select a PDF file',
  duplicateFileName: 'File could not be uploaded due to duplicate file name',
  moreThan20Files: 'You cannot upload more than 20 files in a single upload',
  logUploadSuccess: 'Letter of Credit/Guarantee Uploaded Successfully',
  logDeleteSuccess: 'Letter of Credit/Guarantee Removed Successfully',
  maxFilesExceededError: 'You can only upload a maximum of 10 files.',
  revisionApplication: 'Application Form Revisions Saved Successfully',
  formError:'Please correct the indicated fields. Some values are invalid or missing.',
  invalidFileName: "Invalid file name. Only letters, numbers, '_', '-', and spaces are allowed.",
  max5FilesLimit: "You can only upload up to 5 files.",
  max10FilesLimit: "You can only upload up to 10 files.",
}

export const COMMON_ARREQ = {
  fileNameRegex: /^[a-zA-Z0-9_\-\s]+\.pdf$/,
  uploadCOI: "COI",
  uploadPO: "PO",
}

export const FORM_REGEX = {
  emailRegex: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
  spaceCommaRegx:/[\s,;]+/
}

export const USER_ROLES = {
  system_admin: "System Admin",
  department_user: "Department User",
  department_head: "Department Head",
  client_services: "CSR"
}

export const STUDIO_PARKING_REQUIREMENT = [
  { id: 'radio1', text: 'I REQUIRE AN EXTENDED PASS' },
  { id: 'radio2', text: 'I REQUIRE A DECAL' },
  { id: 'radio3', text: 'I DO NOT REQUIRE PARKING (Selecting this will disable all fields below)' },
];

export const STUDIO_ID_REQUIREMENT = [
  { id: 'radio1', text: 'I REQUIRE A NEW CLIENT ID CARD - Must not have been issued a Client ID Card previously. For long term Non-WB employee tenants, development and business partners, and production personnel working full-time on WB premises in excess of 30 days. The card may be valid for the duration of the assignment not to exceed one (1) year. A new application is required for renewal. The access card will be accompanied by either an extended parking pass or parking decal.' },
  { id: 'radio2', text: 'I REQUEST RENEWAL OF A CLIENT ID CARD - Current assignment is being extended or need to reactivate card for new assignment. Card must still be in possession of the Applicant or Authorized Requestor. A new application is required with new signatures and dates. Use this check box, on the new application, to inform security to only reactivate or extend your current card.' },
  { id: 'radio3', text: 'I REQUEST A REPRINT OF A LOST/DAMAGED CLIENT ID CARD - ID must be active or previously renewed to be reissue or reprinted.' },
  { id: 'radio4', text: 'I DO NOT REQUIRE ID' },
];

export const PARKING_FORM_SUFFIX_LIST = [
  {id: 1, name: "II"},
  {id: 2, name: "III"},
  {id: 3, name: "IV"},
  {id: 4, name: "Jr."},
  {id: 5, name: "Sr."},
];

export const PARKING_CUSTOM_CONTROL = {
  parkingLot: 'parkingLot',
  space: 'space',
  effectiveFrom: 'effectiveFrom',
  effectiveTo: 'effectiveTo'
};

export const DATE_REGEX = {
  dateFormatRegex: /\//g,
}

export const STUDIO_PARKING_ACTION_NAMES_LIST = {
requestorApproveForm: "Requestor Approve Form",
requestorResubmitForm: "Requestor Resubmit Form",
askforRevisions: "Ask for Revisions",
approve: "Approve",
deny: "Deny",
revisionSubmitted: "Revision Submitted",
cancelled: "Cancelled",
securityApprove: "Security Department Resolved Form",
}

export const COGNITO_CSS_REGEX = {
  textTransformRegex: /text-transform:\s*lowercase;/,
  textTransformRegexReplacement: 'text-transform: none;',
}

export const PARKING_FORM_VEHICLE_TYPE_LIST = [
  {id: 1, name: "Primary"},
  {id: 2, name: "Rental"},
];

export const SERVICE_REQUEST_USER_DEFAULT = {
  companyName: "Corporate",
  companyId: 1,
  projectName: "WBD Default Project",
  requestTypeCustomer: "Customer",
  requestTypeCorporate: "Corporate",
  locationTypeCorporate: "Corporate",
  locationTypeCustomer: "Customer"
}

export const NOTIFY_DEPARTMENT_EMAIL_FORMAT = {
  htmldata: '<p>Hello,</p><p>The A/R number is ######</p><p>Billing Information:<br/>$$$$$$</p><p>Thank You</p>'
}

export const USER_PERMISSIONS = {
  editWBSOUser: 'editWBSOUser',
  viewQuote: 'viewQuote',
  uploadQuote: 'uploadQuote',
  editCompany: 'editCompany',
}

export const W9_UPLOAD = {
  title: 'W9',
  uploadW9: 'Upload W9',
  view: 'View',
  remove: 'Remove',
  sectionType: 'companyw9',
  documentType: 'Company',
  acceptType: 'application/pdf',
  maxSize: 5 * 1024 * 1024,
  uploadSuccess: 'File Uploaded Successfully',
  removeSuccess: 'File Removed Successfully',
  uploadError: 'File upload failed. Please try again.',
  removeError: 'File removal failed. Please try again.',
  invalidType: 'File type is not supported. Please select a valid .pdf file',
  sizeExceeded: 'File size exceeds the 5MB limit. Please select a smaller file.',
  removeConfirm: 'Are you sure you want to remove the file?',
  yes: 'Yes',
  cancel: 'Cancel',
}

export const PARKING_FORM_FILE_UPLOAD = {
  headshotImageUpload: 'Headshot Image Upload',
  noImage: 'NA',
  failedToDownload: 'Failed to download headshot image.',
  imageURLUnavailable: 'Headshot image URL is unavailable.',
  headshotImage: 'headshot-image'
}

export const PROJECT_DOCUMENT_SECTION = {
  viewDocument: 'projectdocs',
  downloadDocument: 'projectdocsdownload'
}

export const STUDIO_INQUIRY_STEPS = {
  inquiryTitle: 'Warner Bros. Studios Inquiry',
  required: 'Required',
  steps: [
    'Project Information',
    'Production Company',
    'Studio Operations',
    'Costumes Rentals',
    'Review',
  ],
}

export const STUDIO_INQUIRY_PROJECT_INFO = {
  modalTitle: 'Project Information',
  close: 'Close',
  projectDetails: 'Project Details',
  projectTypeQuestion: 'What type of project is it?',
  projectTypes: [
    'Feature',
    'Television',
    'Live/Production/Rehearsal',
    'Commercial',
    'Still Shoot',
    'Special Event',
    'Other',
  ],
  projectName: 'Project Name',
  projectNamePlaceholder: 'Name',
  projectNameHint: 'Can be Title or DBA',
  projectDates: 'Anticipated Project Dates',
  requiredDate: 'Date is required.',
  invalidDate: 'Invalid date',
  dateFields: [
    {
      id: 'startDate',
      label: 'Start Date',
      required: true,
      rangeMessage: 'Start Date must be before End Date.',
    },
    {
      id: 'shootDate',
      label: 'Shoot Date',
      required: false,
      rangeMessage: '',
    },
    {
      id: 'endDate',
      label: 'End Date',
      required: true,
      rangeMessage: 'End Date must be after Start Date.',
    },
  ],
  scheduleQuestion: 'Anything else we should know about the schedule?',
  schedulePlaceholder: 'Optional',
  back: 'back',
  next: 'Next: Production Company',
}

export const STUDIO_INQUIRY_PRODUCTION_COMPANY = {
  modalTitle: 'Production Company',
  close: 'Close',
  companyNameSection: 'Company Name',
  companyName: 'Company Name',
  contactSection: 'Contact Information',
  contactFields: [
    { id: 'firstName', label: 'First Name' },
    { id: 'lastName', label: 'Last Name' },
    { id: 'email', label: 'Email' },
    { id: 'jobTitle', label: 'Job Title' },
    { id: 'phone', label: 'Phone' },
  ],
  addressSection: 'Company Address',
  country: 'Country',
  selectCountry: 'Select Country',
  street: 'Street',
  city: 'City',
  state: 'State',
  selectState: 'State',
  zipCode: 'Zip Code',
  zipCodePlaceholder: 'ZIP Code',
  addressPhone: 'Phone',
  billingDifferent: 'My billing address is different',
  contactMethodSection: 'Preferred method of contact',
  contactMethods: ['Email', 'Phone'],
  back: 'back',
  next: 'Next: Studio Operations',
}

export const STUDIO_INQUIRY_STUDIO_OPERATIONS = {
  modalTitle: 'Studio Operations',
  close: 'Close',
  locationChoice: 'Location Choice',
  locationLinks: [
    { label: 'Stages', url: 'https://wbstudios.com/stages-sets/sound-stages/' },
    { label: 'Sets', url: 'https://wbstudios.com/stages-sets/exterior-sets/' },
  ],
  soundStages: 'Sound Stages',
  exteriorSets: 'Exterior Sets - Select:',
  exteriorSetOptions: [
    { id: 'newYorkStreet', name: 'New York Street' },
    { id: 'midwestStreet', name: 'Midwest Street' },
    { id: 'brownstoneStreet', name: 'Brownstone Street' },
    { id: 'hennesyStreet', name: 'Hennesy Street' },
    { id: 'frenchStreet', name: 'French Street' },
    { id: 'warnerVillage', name: 'Warner Village' },
    { id: 'theJungle', name: 'The Jungle' },
    { id: 'embassyCourtyard', name: 'Embassy Courtyard' },
    { id: 'parkPlace', name: 'Park Place' },
    { id: 'other', name: 'Other' },
  ],
  additionalRequirements: 'Additional Requirements / Elements to Accomodate:',
  additionalRequirementsPlaceholder: 'For example specific or general exterior set requests, minimal size or weight requirements for stages, special effects/stunts elements, additional support needed',
  officeSpaceQuestion: 'Production Office Space Required?',
  officeSpaceOptions: ['Yes', 'No'],
  back: 'back',
  next: 'Next: Costumes Rentals',
}

export const STUDIO_INQUIRY_COSTUMES_RENTALS = {
  modalTitle: 'Costumes Rentals',
  close: 'Close',
  skipBanner: 'If you do not know your costumes rentals details yet, you can skip this page.',
  pullingInformation: 'Pulling Information',
  descriptionQuestion: 'Give us a brief description of what you will need (Type of items and period)',
  descriptionPlaceholder: 'Optional',
  pullDateQuestion: 'When would you like to come in to pull?',
  pullDate: 'Pull Date',
  racksQuestion: 'How many racks will you need?',
  rackOptions: ['Partial', '1', '2', '3', '4+'],
  visitQuestion: 'Would you like to visit the Collection?',
  contactInformation: 'Costumes Contact Information',
  contactTypeQuestion: 'Primary Contact Type:',
  contactTypes: ['Stylist', 'Designer', 'Set Decorator Property'],
  contactFields: [
    { id: 'firstName', label: 'First Name' },
    { id: 'lastName', label: 'Last Name' },
    { id: 'phone', label: 'Phone' },
  ],
  cloudCheckInQuestion: 'Would this person need Cloud Check In access?',
  cloudCheckInNote: 'Cloud Check In provides 24/7 access to outstanding items on your orders, ability to view and print photos, check in items and print return sheets.',
  addSecondaryContact: 'Add Secondary Contact',
  addAuthorizedShoppers: 'Add Authorized Shoppers',
  shippedQuestion: 'Do you need this order shipped?',
  addressSection: 'Company Address & Billing Information',
  country: 'Country',
  selectCountry: 'Select Country',
  street: 'Street',
  city: 'City',
  state: 'State',
  selectState: 'State',
  zipCode: 'Zip Code',
  addressPhone: 'Phone',
  billingDifferent: 'My billing address is different',
  billingContact: 'Billing Contact:',
  billingContactName: 'Billing Contact Name',
  billingEmail: 'Billing Email',
  billingContactPlaceholder: 'Contact Name',
  billingEmailPlaceholder: 'Email',
  paymentType: 'Payment Type',
  paymentOptions: ['Credit Card', 'Check', 'ACH', 'Apply for a Line of Credit'],
  lineOfCredit: 'Apply for a Line of Credit',
  lineOfCreditNote: 'It is recommended to request a line of credit early in the project as it takes 5 to 7 days for a line of Credit to be reviewed before it can be approved.',
  useBillingForAccountant: 'Use Billing information for Accountant',
  accountantName: 'Accountant Name',
  accountantEmail: 'Accountant Email',
  yesNoOptions: ['Yes', 'No'],
  back: 'back',
  skip: 'Skip Costumes Rentals',
  next: 'Next: Review',
}

export const STUDIO_INQUIRY_REVIEW = {
  modalTitle: 'Review',
  close: 'Close',
  edit: 'Edit',
  services: 'Services',
  project: 'Project',
  projectType: 'Type:',
  projectName: 'Name:',
  startDate: 'Anticipated Start Date:',
  shootDate: 'Anticipated Shoot Date:',
  endDate: 'Anticipated End Date:',
  productionCompany: 'Production Company',
  companyName: 'Name:',
  contactName: 'Contact Information Name:',
  role: 'Role:',
  email: 'Email:',
  phone: 'Phone:',
  preferred: 'Preferred:',
  address: 'Address:',
  studioOperations: 'Studio Operations',
  location: 'Location:',
  soundStages: 'Sound Stages',
  exteriorSets: 'Exterior Sets',
  officeSpace: 'Office Space:',
  costumesRentals: 'Costumes Rentals Request',
  pullingDate: 'Pulling date:',
  racks: 'Racks:',
  visitCollection: 'Visit Collection?',
  primaryContact: 'Primary Contact:',
  cloudCheckInAccess: 'Cloud Check In Access',
  orderShipped: 'Order Shipped?',
  billingAddress: 'Billing Address:',
  billingPhone: 'Billing Phone:',
  billingContact: 'Billing Contact:',
  payment: 'Payment:',
  lineOfCreditPayment: 'Apply for a Line of Credit',
  lineOfCreditNote: '(5 to 7 days for application to be approved)',
  back: 'back',
  submit: 'Submit Inquiry',
}

export const STUDIO_INQUIRY_CONFIRMATION = {
  modalTitle: 'Warner Bros. Studios Inquiry',
  close: 'Close',
  heading: 'Your request has been sent!',
  whatsNext: 'What\'s next?',
  steps: [
    'The selected departments will contact you to discuss your project',
    'You\'ll get rentals forms or quotes via email and decide if you want to do business with us',
  ],
  gotIt: 'Got It!',
}